import React from 'react';
import RouterLink from '../RouterLink';
import LazyPicture from '../LazyPicture';
import { tealiumClickFunc, tealiumMergeClickData } from "../../../utils/tealium";
var CuratorPicks = function CuratorPicks(_ref) {
  var curators = _ref.curators,
    copy = _ref.copy,
    _ref$analytics = _ref.analytics,
    analytics = _ref$analytics === void 0 ? {} : _ref$analytics,
    linksTarget = _ref.linksTarget;
  var baseImage = process.env.REACT_APP_MEDIA_HOST || '';
  if (!curators || curators.length === 0) {
    return null;
  }
  var _analytics$smallBanne = analytics.smallBannerClickAnalytics,
    smallBannerClickAnalytics = _analytics$smallBanne === void 0 ? {} : _analytics$smallBanne,
    _analytics$params = analytics.params,
    params = _analytics$params === void 0 ? {} : _analytics$params,
    _analytics$name = analytics.name,
    name = _analytics$name === void 0 ? '' : _analytics$name;
  return /*#__PURE__*/React.createElement("div", {
    className: "curators__block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "curators__row"
  }, curators.map(function (curator, index) {
    return /*#__PURE__*/React.createElement(RouterLink, {
      key: index,
      linksTarget: linksTarget,
      href: curator.Url,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(smallBannerClickAnalytics, params), name);
      }
    }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: baseImage + curator.Image + '&cw=24&ch=24'
    }), /*#__PURE__*/React.createElement("img", {
      className: "curators__image-item",
      src: baseImage + curator.Image + '&cw=24&ch=24',
      alt: curator.Name
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "curators__author"
  }, copy));
};
export default CuratorPicks;